import { Movimiento } from '../lib/supabase';

export interface TipoBadge {
  readonly label: string;
  readonly clases: string;
}

interface TipoBadgeDefinicion extends TipoBadge {
  readonly aplica: (m: Movimiento) => boolean;
}

// Badges de tipo para movimientos de fondos de paso. Coexisten: un movimiento
// puede matchear más de una condición y mostrar varios badges.
const TIPO_BADGES: ReadonlyArray<TipoBadgeDefinicion> = [
  {
    // Incluye la heurística "egreso de actividad" para mantener transparente el % de
    // utilidad de la actividad (costo donado sigue registrado como costo). Regla de
    // dominio intencional: permite comparar/replicar actividades entre Lumisiales.
    aplica: (m) =>
      m.donacion_de_miembro_id != null ||
      m.donacion_de_nombre_externo != null ||
      (m.origen_tipo === 'actividad' && m.afecta_balance === false && m.tipo === 'egreso'),
    label: 'Donación',
    clases: 'bg-violet-100 text-violet-700',
  },
  {
    aplica: (m) => m.requiere_reembolso === true,
    label: 'Reembolso',
    clases: 'bg-orange-100 text-orange-700',
  },
  {
    aplica: (m) => m.categoria_aporte === 'cuota_iglesia' || m.origen_tipo === 'transferencia_cuota_iglesia',
    label: 'Cuota Iglesia',
    clases: 'bg-blue-100 text-blue-700',
  },
  {
    aplica: (m) => m.origen_tipo === 'campaña',
    label: 'Campaña',
    clases: 'bg-pink-100 text-pink-700',
  },
];

export function getTipoBadges(m: Movimiento): TipoBadge[] {
  return TIPO_BADGES.filter((b) => b.aplica(m));
}
